import { makeStyles } from '@material-ui/core/styles'
import { Alert, IconButton } from '@mui/material'
import LoadingModal from 'src/components/common/LoadingModal'
import CloseIcon from '@mui/icons-material/Close'
import TeleConsultationImage from 'src/assets/Buy_Policy_Images/TeleConsultation.svg'
import { saveNSTPData } from 'src/services/buyPolicyService'
import { getTokenForQrReport } from 'src/services/individualService'
import { useEffect, useState } from 'react'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { clearGuestDetails, showNotificationMessage } from 'src/actions'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
  DETAILS_SUBMITTED_SUCCESFULLY,
  ERROR_SENDING_DATA,
} from 'src/utils/constants/Health'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'

const TeleConsultationModal = ({
  onClose,
  proposerDetails,
  memberDetails,
  selectedQuote,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const history = useHistory()

  const fetchData = async () => {
    setLoading(true)
    try {
      const tokenResponse = await getTokenForQrReport()

      if (tokenResponse?.res?.status === 200) {
        const token = tokenResponse?.res?.data?.access_token

        const formData = {
          proposerDetails,
          memberDetails,
          selectedQuote,
        }

        const apiResponse = await saveNSTPData(token, formData)

        if (apiResponse?.res?.data?.success) {
          setSuccessMessage(DETAILS_SUBMITTED_SUCCESFULLY)
          setTimeout(() => {
            clearStateAndNavigate()
          }, 10000)
        } else {
          dispatch(
            showNotificationMessage({
              type: NOTIFICATION_TYPES?.ERROR,
              message:
                NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
            })
          )
        }
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
          })
        )
      }
      setLoading(false)
    } catch (error) {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ERROR_SENDING_DATA,
        })
      )
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [proposerDetails, memberDetails, selectedQuote])

  const handleClose = () => {
    onClose()
  }

  const clearStateAndNavigate = () => {
    dispatch(clearGuestDetails())
    history.push('/individual/dashboard/buyPolicy/health')
  }

  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.mainContainer}>
        <div className={classes.closeButton}>
          <IconButton onClick={handleClose} id='IconButton'>
            <CloseIcon />
          </IconButton>
        </div>
        <div>
          <div className={classes.headingContainer}>
            <span className={classes.heading}>
              <span className={classes.headingText}>Teleconsultation</span>{' '}
              might be required in your case.
            </span>
            <br></br>
            <span className={classes.heading}>
              Our <span className={classes.headingText}>officer will call</span>{' '}
              you back soon.
            </span>
          </div>
          <div className={classes.imageContainer}>
            <div className={classes.imageContent}>
              <img
                src={TeleConsultationImage}
                alt='teleConsultation'
                className={classes.image}
              />
            </div>
            <div className={classes.textContent}>
              {successMessage && (
                <div className={classes.successMessage}>
                  <Alert severity='success'>{successMessage}</Alert>
                  <span className={classes.reloadText}>
                    Redirecting to Home page in 10 seconds ...
                  </span>
                </div>
              )}
              <div className={classes.queriesContent}>
                <span className={classes.queriesText}>For further queries</span>
              </div>
              <div>
                <span className={classes.contactText}>Please call us at </span>
                <span className={classes.contact}> 18003099247</span>
                <br></br>
                <span className={classes.contactText}> or write at </span>
                <span className={classes.contact}> help@trovity.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TeleConsultationModal

const useStyles = makeStyles({
  mainContainer: {
    background: '#FFF',
    borderRadius: '20px',
  },
  closeButton: {
    textAlign: 'right',
    padding: '10px 10px 0px 10px',
    color: '#BDBDBD',
  },
  headingContainer: {
    padding: '0px 40px 10px 40px',
  },
  heading: {
    fontSize: '21px',
    lineHeight: '31px',
    fontWeight: '300',
  },
  headingText: {
    fontSize: '21px',
    lineHeight: '31px',
    fontWeight: '600',
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: '30px',
  },
  textContent: {
    textAlign: 'center',
  },
  queriesContent: {
    padding: '10px 0px',
  },
  queriesText: {
    fontSize: '18px',
    color: '#545454',
    fontStyle: 'italic',
    lineHeight: '21px',
    fontWeight: '300',
  },
  contactText: {
    fontSize: '17px',
    lineHeight: '22px',
  },
  contact: {
    fontSize: '17px',
    color: '#28BEE7',
    fontWeight: '700',
    lineHeight: '22px',
  },
  image: {
    width: '345px',
  },
  reloadText: {
    fontSize: '12px',
    color: 'rgba(0,0,0,.5)',
    fontStyle: 'italic',
  },
})
